import { render, staticRenderFns } from "./Capa.vue?vue&type=template&id=7c09c38d&"
import script from "./Capa.vue?vue&type=script&lang=js&"
export * from "./Capa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports